import { Grid, Select, TextField } from '@medely/web-components';
import { Button } from '@medely/ui-kit';
import { Field, Form } from 'react-final-form';
import { composeValidation, email, password, required } from 'core/utils/validation';
import React from 'react';
import useSignUp from './useSignUp';

const emailValidation = composeValidation(required, email);

const KINDS_OPTIONS = [
  { label: 'Allied (Physician Assistants, CNAs, Techs, Therapists)', value: 'allied' },
  { label: 'Imaging Services', value: 'imaging_services' },
  { label: 'LVN', value: 'lvn' },
  { label: 'Registered Nurse (includes NPs)', value: 'registered_nurse' },
];

const SignUpForm = (): React.ReactElement => {
  const signUp = useSignUp();
  return (
    <Form initialValues={{}} onSubmit={signUp}>
      {({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Field name="account[email]" validate={emailValidation}>
                {({ input, meta }) => (
                  <TextField
                    type="email"
                    label="Email"
                    placeholder="Email"
                    fullWidth
                    {...input}
                    error={meta.touched && meta.invalid}
                    helperText={meta.touched && meta.error}
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field name="professional[kinds]" validate={required}>
                {({ input, meta }) => (
                  <Select
                    textFieldProps={{
                      label: 'Select a position',
                      error: meta.touched && meta.invalid,
                      helperText: meta.touched && meta.error,
                      fullWidth: true,
                    }}
                    value={KINDS_OPTIONS.find((option) => option.value === input.value)}
                    onChange={(option) => input.onChange(option.value)}
                    options={KINDS_OPTIONS}
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Field name="account[password]" validate={password}>
                {({ input, meta }) => (
                  <TextField
                    label="Password"
                    placeholder="Password"
                    type="password"
                    fullWidth
                    {...input}
                    error={meta.touched && meta.invalid}
                    helperText={meta.touched && meta.error}
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                fullWidth
                disabled={submitting}
              >
                Apply to Work
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Form>
  );
};

export default SignUpForm;
